import { render, staticRenderFns } from "./ReportTemplate2.vue?vue&type=template&id=74119a2d&"
import script from "./ReportTemplate2.vue?vue&type=script&lang=js&"
export * from "./ReportTemplate2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports